import React from 'react';

export const MobileInputField = props => (
  <label className="block mt-10 relative">
    <span className=" block text-xs capitalize">Mobile Number </span>
    <div className="relative mt-1 ">
      <div className="absolute text-grey-50 z-10 mt-2 pt-px text-md ml-4" >
        +91
      </div>
      <input
        className="  pl-12 placeholder-grey-placeholder form-input  rounded-sm mt-1  block w-full"
        type="number"
        id="phone"
        name={props.name}
        placeholder="Enter Your Mobile Number"
        onChange={e => {
          props.handleChange(e);
          props.setMobile(e.target.value);
        }}
        onKeyPress={(e, inputLength) => {
          props.validatePhoneNumber(e, inputLength);
        }}
        onBlur={e => {
          props.handleBlur(e);
        }}
        required
        minLength="10"
        maxLength="10"
        autoFocus
      />
    </div>
  </label>
);
